module.exports = __webpack_public_path__ + "img/colors_icon.00dc48b5.svg";